import type { Feature } from 'geojson';

const nameKey = (name: string) => name.trim().toLowerCase();

export function uniqueFeatureName(name: string, features: Feature[], excludeId?: string | number): string {
  return reserveFeatureName(name, new Set(features
    .filter((feature) => excludeId == null || String(feature.id) !== String(excludeId))
    .map((feature) => nameKey(String(feature.properties?.['name'] ?? '')))));
}

function reserveFeatureName(name: string, used: Set<string>): string {
  const trimmed = name.trim();
  if (!trimmed) return '';
  let candidate = trimmed;
  const base = trimmed.replace(/ \(\d+\)$/, '');
  let suffix = 2;
  while (used.has(nameKey(candidate))) candidate = `${base} (${suffix++})`;
  used.add(nameKey(candidate));
  return candidate;
}

export function nameImportedFeatures(features: Feature[], existing: Feature[]): Feature[] {
  const used = new Set(existing.map((feature) => nameKey(String(feature.properties?.['name'] ?? ''))));
  return features.map((feature) => {
    const name = String(feature.properties?.['name'] ?? '');
    if (!name.trim()) return feature;
    return { ...feature, properties: { ...feature.properties, name: reserveFeatureName(name, used) } };
  });
}
